import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import TemplateRenderer from "@/components/resume-builder/templates/TemplateRenderer";
import { SAMPLE_RESUME_DATA } from "@/data/galleryTemplates";
import { COLOR_THEMES } from "@/components/resume-builder/templates/templateConfig";

export default function TemplatePreviewModal({ template, open, onClose, onUse }) {
  const [colorId, setColorId] = useState(template?.colorId || "indigo");

  useEffect(() => {
    if (template) setColorId(template.colorId);
  }, [template]);

  if (!template) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl bg-[#12141c] border-white/10 p-0" data-testid="template-preview-modal">
        <DialogTitle className="sr-only">{template.name} resume template preview</DialogTitle>
        <div className="p-6 max-h-[78vh] overflow-y-auto">
          <p className="text-lg font-heading font-semibold text-white">{template.name}</p>
          <p className="text-xs text-slate-400 mb-4">{template.style} · Recommended for {template.roleLevel.join("/")}</p>

          <div className="flex items-center gap-2 mb-4">
            {COLOR_THEMES.map((c) => (
              <button
                key={c.id} onClick={() => setColorId(c.id)} title={c.label} data-testid={`template-modal-color-${c.id}`}
                className={`w-6 h-6 rounded-full transition-transform ${colorId === c.id ? "ring-2 ring-white scale-110" : "hover:scale-105"}`}
                style={{ backgroundColor: c.hex }}
              />
            ))}
          </div>

          <div className="bg-slate-100 rounded-lg p-4" data-testid="template-modal-preview">
            <TemplateRenderer templateId={template.id} colorId={colorId} draft={SAMPLE_RESUME_DATA} />
          </div>

          <button
            onClick={() => onUse(template, colorId)} data-testid="template-modal-use-btn"
            className="w-full mt-5 flex items-center justify-center gap-2 bg-indigo-500 hover:bg-indigo-400 text-white font-semibold py-2.5 rounded-lg transition-colors"
          >
            <Sparkles className="w-4 h-4" /> Use this Template
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
